@use "variables" as *;

.button {
  text-transform: initial !important;
  white-space: pre-wrap !important;
}

.noMessagesText {
  font-size: $fontSize-s;
  align-self: center;
  justify-self: center;
  text-align: center;
  width: 100%;
}
